import React, { Component } from 'react'
import { Switch, Route } from 'react-router-dom'
import { routerActions } from 'connected-react-router'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { Container, Menu, Grid, Header, Loader, Dimmer } from 'semantic-ui-react'
import AppHeader from '../components/AppHeader'
import FacilityList from './admin/FacilityList'
import EventList from './admin/EventList'
import StaffList from './admin/StaffList'
import VenueList from './admin/VenueList'
import CreateEvent from './admin/CreateEvent'
import Facility from './admin/Facility'
import CreateStaff from './admin/CreateStaff'
import { withAdalLoginApi, authContext } from '../adalConfig'
import EditStaff from './admin/EditStaff'
import CreateVenue from './admin/CreateVenue'
import EditVenue from './admin/EditVenue'
import EditEvent from './admin/EditEvent'
import EditReservation from './admin/EditReservation'
import ReservationList from './admin/ReservationList'
import InventoryList from './admin/InventoryList'
import PaymentLinkList from './admin/PaymentLinkList'
import CreatePaymentLink from './admin/CreatePaymentLink'

import * as Venue from '../store/Venue'
import * as FacilityStore from '../store/Facility'
import * as Staff from '../store/Staff'
import * as Events from '../store/Events'
import * as Reservation from '../store/Reservations'
import * as PaymentLink from '../store/PaymentLinks'

import Reports from './admin/Reports'

const signOut = (e) => {
    e.preventDefault()
    authContext.logOut()
}

class AdminPage extends Component {
    constructor(props) {
        super(props)
        this.state = {
            activeItem: 'events',
            loading: false,
        }
        this.onMenuClick = this.onMenuClick.bind(this)
    }

    componentDidMount() {
        const { actions } = this.props
        actions.getReservations()
        actions.getEvents()
        actions.getFacilities()
        actions.getStaff()
        actions.getVenue()
        actions.getInventoryList()
        actions.getPaymentLinks()
    }

    async onMenuClick(e, { name }) {
        const { actions } = this.props
        this.setState({ activeItem: name, loading: true })
        switch (name) {
            case 'events':
                await actions.getEvents()
                this.setState({ loading: false })
                break
            case 'inventory':
                await actions.getInventoryList()
                this.setState({ loading: false })
                break
            case 'reservations':
                await actions.getReservations()
                this.setState({ loading: false })
                break
            case 'facilities':
                await actions.getFacilities()
                this.setState({ loading: false })
                break
            case 'venues':
                await actions.getVenue()
                this.setState({ loading: false })
                break
            case 'staff':
                await actions.getStaff()
                this.setState({ loading: false })
                break
            case 'reporting':
                this.setState({ loading: false })
                break
            case 'paymentLinks':
                await actions.getPaymentLinks()
                this.setState({ loading: false })
                break
            default:
                break
        }
        if (name === 'logout') {
            signOut(e)
        } else {
            if (window.location.pathname !== '/admin') {
                actions.replace('/admin')
            }
        }
    }

    render() {
        const { activeItem, loading } = this.state
        return (
            <div className="app">
                <AppHeader />
                <div className="bigimage"></div>
                <Container className="admin">
                    <Header className="page title" as="h1" content="Configuration" />
                    <Grid>
                        <Grid.Column width={3}>
                            <Menu vertical fluid>
                                <Menu.Item name="events" active={activeItem === 'events'} onClick={this.onMenuClick} />
                                <Menu.Item name="inventory" active={activeItem === 'inventory'} onClick={this.onMenuClick} />
                                <Menu.Item name="reservations" active={activeItem === 'reservations'} onClick={this.onMenuClick} />
                                <Menu.Item name="facilities" content="Parking Facilities" active={activeItem === 'facilities'} onClick={this.onMenuClick} />
                                <Menu.Item name="venues" content="Event Venues" active={activeItem === 'venues'} onClick={this.onMenuClick} />
                                <Menu.Item name="staff" active={activeItem === 'staff'} onClick={this.onMenuClick} />
                                <Menu.Item name="reporting" active={activeItem === 'reporting'} onClick={this.onMenuClick} />
                                <Menu.Item name="paymentLinks" active={activeItem === 'paymentLinks'} onClick={this.onMenuClick} />
                                <Menu.Item name="logout" active={activeItem === 'logout'} onClick={this.onMenuClick} />
                            </Menu>
                        </Grid.Column>
                        <Grid.Column width={13}>
                            <Switch>
                                <Route path="/admin/reservation/:confirmation" component={EditReservation} />
                                <Route path="/admin/facility/:facilityId" component={Facility} />
                                <Route exact path="/admin/event/add" component={CreateEvent} />
                                <Route path="/admin/event/:eventId" component={EditEvent} />
                                <Route exact path="/admin/staff/add" component={CreateStaff} />
                                <Route path="/admin/staff/:staffId" component={EditStaff} />
                                <Route exact path="/admin/venue/add" component={CreateVenue} />
                                <Route path="/admin/venue/:venueId" component={EditVenue} />
                                <Route exact path="/admin/paymentLink/add" component={CreatePaymentLink} />
                                <Route
                                    render={() => (
                                        <div>
                                            <Dimmer active={loading}>
                                                <Loader />
                                            </Dimmer>
                                            {activeItem === 'events' ? <EventList /> : null}
                                            {activeItem === 'facilities' ? <FacilityList /> : null}
                                            {activeItem === 'staff' ? <StaffList /> : null}
                                            {activeItem === 'venues' ? <VenueList /> : null}
                                            {activeItem === 'reservations' ? <ReservationList /> : null}
                                            {activeItem === 'inventory' ? <InventoryList /> : null}
                                            {activeItem === 'reporting' && <Reports />}
                                            {activeItem === 'paymentLinks' && <PaymentLinkList />}
                                        </div>
                                    )}
                                />
                            </Switch>
                        </Grid.Column>
                    </Grid>
                </Container>
            </div>
        )
    }
}

AdminPage.propTypes = {}

const mapStateToProps = (state, ownProps) => {
    return {}
}

const mapDispatchToProps = (dispatch) => ({
    actions: {
        ...bindActionCreators(Events.actionCreators, dispatch),
        ...bindActionCreators(FacilityStore.actionCreators, dispatch),
        ...bindActionCreators(Staff.actionCreators, dispatch),
        ...bindActionCreators(Venue.actionCreators, dispatch),
        ...bindActionCreators(Reservation.actionCreators, dispatch),
        ...bindActionCreators(PaymentLink.actionCreators, dispatch),
        ...bindActionCreators(routerActions, dispatch),
    },
})

export default withAdalLoginApi(
    connect(
        mapStateToProps,
        mapDispatchToProps
    )(AdminPage),
    () => <div>Loading</div>,
    () => <div>error</div>
)
